import React from "react";
import { Create, SimpleForm } from "react-admin";

import { SaveWithCancelToolbar } from "../../../components/toolbars/SaveWithCancelToolbar";
import { TerminalSettingPerDateForm } from "../forms/TerminalSettingPerDateForm";

export const TerminalSettingPerDateCreate = (props) => (
	<Create {...props}>
		<SimpleForm
			submitOnEnter={false}
			toolbar={<SaveWithCancelToolbar />}
			redirect="list"
		>
			<TerminalSettingPerDateForm />
		</SimpleForm>
	</Create>
);
